module.exports = __webpack_public_path__ + "img/ipad-player.8c95b904.svg";